import { timeFormat } from 'common/helpers/dateHelper';

const EventTime = (props) => {
  const { product, settings } = props;
  if (product.eventTicket?.eventDate) {
    return timeFormat(product.eventTicket.eventDate, settings);
  }
  return null;
};

export default EventTime;
